import VisitorsLogPageView from "./VisitorsLogPageView";

function VisitorsLogPage() {
  return <VisitorsLogPageView />;
}

export default VisitorsLogPage;
